import * as React from 'react';
import { useMutation } from '@apollo/react-hooks';
import { NavButton } from '@amount/frontend-components';

import { TakeoverLoader } from '../TakeoverLoader';
import { devToolsEnabled, IProductUuid } from '../../common';
import { devToolsClient } from '../../devToolsApolloClient';

import ConfirmSsnMutation, {
  ConfirmSsn as ConfirmSsnData,
  ConfirmSsnInput
} from './queries/ConfirmSsn.graphql';

export const ConfirmSsn: React.FC<IProductUuid> = ({ uuid }) => {
  if (!devToolsEnabled()) {
    return null;
  }
  const [confirmSsn, { loading }] = useMutation<ConfirmSsnData, ConfirmSsnInput>(
    ConfirmSsnMutation,
    {
      variables: { input: { customerApplicationUUID: uuid }},
      client: devToolsClient,
    },
  );

  const onClick = async () => {
    const response = await confirmSsn();

    if (response.data?.confirmSsn?.success) {
      window.location.reload();
    } else {
      alert('Failed, see backend error log');
    }
  };

  return (
    <>
      {
        loading && (
          <TakeoverLoader />
        )
      }
      <NavButton onClick={onClick}>
        Confirm SSN
      </NavButton>
    </>
  );
};
